import 'twin.macro';
import 'styled-components/macro';

import { ButtonHTMLAttributes } from 'react';

import { Icon } from 'component-lib';

interface BaseButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
}

interface ButtonProps extends BaseButtonProps {
  variant?: 'filled' | 'outline';
}

export const Button = ({ variant = 'filled', ...props }: ButtonProps) => {
  if (variant === 'filled') {
    return <FilledButton {...props} />;
  }

  return <OutlineButton {...props} />;
};

const FilledButton = ({ children, ...props }: BaseButtonProps) => (
  <BaseButton
    tw="
      text-white
      text-base

      bg-green/100
      border-green

      hover:(bg-green/80)
      active:(bg-green/60)
      disabled:(bg-green/20 text-green)
      focus-visible:(ring ring-green/20)
    "
    {...props}
  >
    {children}
  </BaseButton>
);

const OutlineButton = ({ children, ...props }: BaseButtonProps) => (
  <BaseButton
    tw="
      text-white
      text-base

      border-1
      border-white/70

      bg-white/0

      hover:not-disabled:(border-white bg-white/5)
      active:not-disabled:(border-white/70 bg-white/10)
      disabled:(text-white/20 ring-white/20 border-white/20)
      focus-visible:(border-white/100 ring ring-white/10 bg-white/10)
    "
    {...props}
  >
    {children}
  </BaseButton>
);

const BaseButton = ({ disabled, loading, children, ...props }: BaseButtonProps) => (
  <button
    disabled={disabled || loading}
    aria-label={loading ? 'loading' : undefined}
    tw="
      min-h-[2.5rem]

      px-3
      py-half

      rounded-xs

      transition-all
      duration-fast

      outline-none
    "
    {...props}
  >
    {loading ? <Icon name="circle-loader" tw="animate-spin transition-all duration-fast leading-normal" /> : children}
  </button>
);
